export default __webpack_public_path__ + "images/50b137c6264ab5a67548531733915a9f-blues_and_jazz.jpg";